/**
 * Created by Phatbass on 21/02/16.
 */

'use strict';

// TODO: Add all urls
angular.module('far.models.userAchievements', [])
    .service('userAchievements', function ($log, $http) {
        var list = [];

        Object.defineProperty(this, 'list', {
            get: function () {
                $http.get(Routing.generate('api_get_user_achievement_type_list'))
                    .then(function (response) {
                        response.data.forEach(function (routeData) {
                            list.push({
                                id: routeData.id,
                                name: routeData.name
                            });
                        });
                    }, function errorCallback(response) {
                        $log.error(response);
                    });

                return list;
            }
        });
    });